import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { DashboardEnhanced } from '../DashboardEnhanced';
import { UsersManagement } from '../UsersManagement';
import { ProjectsList } from '../../pages/ProjectsList';
import { ProjectDetail } from '../../pages/ProjectDetail';
import { SettingsPage } from '../../pages/SettingsPage';

export const DashboardLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = window.location.pathname;

  return (
    <div className="min-h-screen bg-slate-50/50 flex">
      <div className="hidden md:flex w-64 flex-col fixed inset-y-0 z-50 bg-slate-900 text-white border-r border-slate-800">
        <div className="p-6 border-b border-slate-800">
          <div className="text-2xl font-black tracking-tighter">TrackBuild.ca</div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          <button
            onClick={() => navigate('/')}
            className={`w-full text-left px-4 py-2 rounded-md transition-colors ${location === '/' ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`}
            data-testid="nav-dashboard"
          >
            Dashboard
          </button>
          <button
            onClick={() => navigate('/projects')}
            className={`w-full text-left px-4 py-2 rounded-md transition-colors ${location.includes('/projects') ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`}
            data-testid="nav-projects"
          >
            Projects
          </button>
          {user?.role === 'admin' && (
            <button
              onClick={() => navigate('/users')}
              className={`w-full text-left px-4 py-2 rounded-md transition-colors ${location === '/users' ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`}
              data-testid="nav-users"
            >
              Users
            </button>
          )}
          <button
            onClick={() => navigate('/settings')}
            className={`w-full text-left px-4 py-2 rounded-md transition-colors ${location === '/settings' ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800 hover:text-white'}`}
            data-testid="nav-settings"
          >
            Settings
          </button>
        </nav>
        <div className="p-4 border-t border-slate-800">
          <div className="text-sm text-slate-400 mb-2">{user?.full_name}</div>
          <div className="text-xs text-slate-500 mb-3">{user?.email}</div>
          <button
            onClick={logout}
            className="w-full text-left px-4 py-2 text-sm text-slate-300 hover:bg-slate-800 rounded-md transition-colors"
            data-testid="logout-button"
          >
            Logout
          </button>
        </div>
      </div>
      <div className="flex-1 md:pl-64 flex flex-col">
        <header className="flex items-center justify-between border-b px-6 py-4 bg-white sticky top-0 z-10">
          <div className="text-xl font-bold text-slate-900">{user?.full_name}</div>
          <div className="text-sm text-slate-500">{user?.role === 'admin' ? 'Administrator' : 'User'}</div>
        </header>
        <main className="flex-1 p-6">
          <Routes>
            <Route index element={<DashboardEnhanced />} />
            <Route path="projects" element={<ProjectsList />} />
            <Route path="projects/:projectId" element={<ProjectDetail />} />
            <Route path="users" element={<UsersManagement />} />
            <Route path="settings" element={<SettingsPage />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
